module.exports = __webpack_public_path__ + "components/country-flag/static/bn-a7ea5e1372c7bac6d14a7f1d668b20f5.svg";